module.exports = __webpack_public_path__ + "media/images/writer/community/sp-headline-about-rule@3x-7f4e5252282af594dd9ece55ef4d30a6.png";